import React from 'react';

/**
 * App-owned add-water glyph. The tapered glass provides the object, the wave
 * distinguishes water from an empty cup, and the separate plus makes the action
 * legible without relying on color.
 */
const WaterGlassPlusIcon = ({ className = '' }) => (
  <svg
    data-icon="water-glass-plus"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
    focusable="false"
  >
    <path
      data-part="glass"
      d="M4.5 4.5h10l-1.2 15H5.7l-1.2-15Z"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.05 11.55c1.45-.78 2.82.72 4.27 0 1.33-.67 2.6.45 4.03.08l-.55 6.95H6.2l-.58-7.25"
      fill="currentColor"
      opacity="0.38"
    />
    <path
      data-part="waterline"
      d="M5.05 11.55c1.45-.78 2.82.72 4.27 0 1.33-.67 2.6.45 4.03.08"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      data-part="plus"
      d="M18.5 5v7M15 8.5h7"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
  </svg>
);

export default WaterGlassPlusIcon;
